"use strict";

var initSelect = function initSelect($el) {
    if ($el.hasClass("select2")) {
        $el.select2();
    } else if ($el.data("url")) {
        var val = $el.val();
        $el.html("");
        $.ajax({
            url: $el.data("url"),
            type: "get"
        }).done(function (data) {
            if ($el.attr("placeholder") !== undefined) {
                $el.append($("<option>", {
                    value: "",
                    text: $el.attr("placeholder"),
                    selected: !val
                }));
            }
            $.each(data, function (i, v) {
                $el.append($("<option>", {
                    value: v.value,
                    text: v.text,
                    title: v.title,
                    selected: v.value.toString() === val
                }));
            });
        });
    }
};
$.fn.initParamGene = function () {
    var $this = $(this);
    $.each($(".parametrage form select"), function (i, el) {
        var $el = $(el),
            $optionsToLoad = $el.find("option[data-url]");
        if ($optionsToLoad.length > 0) {
            $.each($optionsToLoad, function (i, o) {
                var $o = $(o);
                $.ajax({
                    url: $o.data("url"),
                    type: "get",
                    data: {
                        search: $o.val()
                    }
                }).done(function (data) {
                    $o.text(data.text);
                    initSelect($el);
                });
            });
        } else {
            initSelect($el);
        }
    });
    $(".parametrage form i.cursor-hand").on("click", function () {
        var $parent = $(this).parent(),
            $select = $parent.find("select"),
            $row = $parent.parents(".row:first");
        $select.val("").trigger("change");
        //$row.find("select.select2, input[type=number], input:text, input:checkbox").val("").trigger("change").parents("[class^=col-md-]:first").addClass("d-none");
    });
    $(".parametrage button#delete-all-indicateur").on("click", function () {
        var $this = $(this),
            $suppIndic = $(".indicateur-dashboard").find("i.cursor-hand");
        $suppIndic.trigger("click");
    });
    $(".parametrage .indicateur-dashboard select.custom-select").on("change", function () {
        var $this = $(this),
            $parent = $this.parent(),
            $row = $parent.parents(".row:first"),
            $select2 = $row.find("select.select2"),
            $input = $row.find("input[type=number]"),
            $libelle = $row.find("input:text"),
            $checkBox = $row.find("input:checkbox"),
            val = $this.val();
        if (val === "1") {
            $select2.parents(".indic-tasks").removeClass("d-none");
            $input.val("").parents(".indic-jour").addClass("d-none");
        } else if (val === "2") {
            $select2.val("").trigger("change").parents(".indic-tasks").addClass("d-none");
            $input.parents(".indic-jour").removeClass("d-none");
        } else {
            $select2.val("").trigger("change").parents(".indic-tasks").addClass("d-none");
            $input.val("").parents(".indic-jour").addClass("d-none");
        }
        if (val) {
            $checkBox.parents(".indic-onlyMyItems").removeClass("d-none");
            $libelle.parents(".indic-libelle").removeClass("d-none");
        } else {
            $checkBox.removeAttr("checked").parents(".indic-onlyMyItems").addClass("d-none");
            $libelle.parents(".indic-libelle").addClass("d-none");
        }
    });
    $(".parametrage form button:submit").on("click", function (e) {
        e.preventDefault();
        var $this = $(this),
            $form = $this.parents("form:first"),
            datas = [];
        if (!$form.valid()) {
            return false;
        }
        var valid = true;
        $.each($(".indicateur-dashboard select.custom-select"), function (i, el) {
            var $el = $(el),
                $parent = $el.parent(),
                $row = $parent.parents(".row:first"),
                $select2 = $row.find("select.select2"),
                $input = $row.find("input[type=number]"),
                val = $el.val();
            if (val !== null && val !== "") {
                if (val === "1" && ($select2.val() === null || $select2.val() === "" || $select2.attr("multiple") && $select2.val().length === 0)) {
                    valid = false;
                } else if (val === "2" && ($input.val() === undefined || $input.val() === "")) {
                    valid = false;
                }
                if (!valid) {
                    return false;
                }
            }
            return true;
        });
        if (!valid) {
            return false;
        }
        $.each($form.find("div.form-param"), function (i, p) {
            datas.push($("input, select", p).serializeJSONObject(true));
        });
        var fd = new FormData();
        fd.append("param", JSON.stringify(datas));
        fd.append("isAdmin", $this.data("is-admin"));
        $.ajax({
            url: $form.attr("action"),
            method: "post",
            processData: false,
            contentType: false,
            data: fd
        }).done(function (data) {
            document.location.reload();
        });
    });
    return $this;
};
$(".parametrage").initParamGene();


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Account/parametrage.ts
// module id = 602
// module chunks = 0